import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";
function field(props) {
  const { scrDefinition, fData } = props;
  const jprop = JSON.parse(fData.JPROP) || {};
  return (
    <div
      id={`swf-${fData.FIELD_ID}`}
      key={fData.FIELD_ID}
      className="scr-field"
    >
      <div id={`swf-${fData.FIELD_ID}`} className="scr-field">
        <div id={`swfl-${fData.FIELD_ID}`} className="scr-field-label">
          {jprop.caption}
        </div>
        <div id={`swfv-${fData.FIELD_ID}`} className="scr-field-value">
          VALOARE {fData.FIELD_CODE}
        </div>
      </div>
    </div>
  );
}
export default observer(field);
